import { FC, useState } from "react";
import { Stack } from "@mui/material";
import { GridApi } from "ag-grid-community";
import { usersTableColumnsDefs } from "./usersTableColumnsDefs";
import { UsersListToolbar } from "./UsersListToolbar";
import { useGetV2UsersMeOrganisationsCurrentUsersQuery } from "@/services/cloudchipr.api";
import { AgDataGrid } from "@/components/pages/common/ag-grid/AgDataGrid";

export const UsersList: FC = () => {
  const { data } = useGetV2UsersMeOrganisationsCurrentUsersQuery({});
  const [gridApi, setGridApi] = useState<GridApi | null>(null);

  return (
    <Stack height="100%" bgcolor="white">
      <UsersListToolbar gridApi={gridApi} usersCount={data?.length ?? 0} />

      <AgDataGrid
        rowHeight={48}
        headerHeight={52}
        rowData={data}
        columnDefs={usersTableColumnsDefs}
        defaultColDef={defaultColDef}
        gridApiSetter={setGridApi}
      />
    </Stack>
  );
};

const defaultColDef = {
  flex: 5,
  minWidth: 180,
  sortable: true,
  unSortIcon: true,
  filter: "agMultiColumnFilter",
};
